// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/default.scss
// module id = 589
// module chunks = 376